import { cn } from '../../lib/css/className/className';

export const cnTheme = cn('Theme');
